import React from 'react';
import { Box, Typography } from '@mui/material';

export interface ConfigDetailRowProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  alignItems?: 'center' | 'flex-start';
}

export function ConfigDetailRow({
  icon,
  label,
  value,
  alignItems = 'center',
}: ConfigDetailRowProps) {
  return (
    <Box sx={{ display: 'flex', alignItems, gap: 1.5 }}>
      <Box
        sx={{
          color: 'text.secondary',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          mt: alignItems === 'flex-start' ? '2px' : 0,
        }}
      >
        {icon}
      </Box>
      <Typography variant="body2" component="span" sx={{ fontWeight: 500, color: 'text.primary' }}>
        {label}:{' '}
        <Typography variant="body2" component="span" sx={{ fontWeight: 400, color: 'text.secondary' }}>
          {value}
        </Typography>
      </Typography>
    </Box>
  );
}
